// ENG-5435: hybrid kanban-work — manager-side prompt injected into the
// agent's REPL on each manager poll tick where the board has actionable
// (todo / in_progress) items. As of ENG-5662 this is the SOLE kanban-work
// mechanism (the `claude -p kanban-work` cron and the in-session
// `/loop kanban-work` arm it replaced have been removed) and it runs
// unconditionally for persistent claude-code agents — no env flag gates it.
//
// This command is NOT a slash command — it's plain text the agent reads as
// a user message, then follows the Kanban Work Policy from CLAUDE.md. It
// must stay single-line and short: anything over ~80 chars trips Claude
// Code's bracketed-paste detection and the message lands as a "Pasted text
// #N" blob instead of typed input.
//
// The full policy ("use judgement, don't interrupt mid-task, run through
// to completion") lives in CLAUDE.md — the trigger just nudges.

export const KANBAN_CHECK_COMMAND = 'kanban_list — pick up any actionable items if you are free.';
